/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import { getFile, showModal } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { withRouter, Link } from "react-router-dom";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";

class Profilebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      file: null,
    };
  }

  fetchProfileImage = () => {
    if (Object.keys(this.props.generalProfile).length === 0) return;
    this.props.getFile(
      this.props.generalProfile.imagePath,
      () => { },
      (file) => {
        this.setState({
          file: file,
        });
      },
      (err) => {
        // console.log(err);
      },
      true
    );
  };

  componentDidMount() {
    if (Object.keys(this.props.generalProfile).length !== 0) {
      this.fetchProfileImage();
    }
  }

  renderUserImage = () => {
    const img = this.state.file
      ? this.state.file.binary
      : "/img/ford-gelisim-akademisi-avatar.svg";
    return (
      <div
        className="userImg"
        style={{
          backgroundImage: `url(${img})`,
        }}
      ></div>
    );
  };

  render() {
    if (Object.keys(this.props.generalProfile).length === 0) return null;

    return (
      <>
        <a href="#">
          <div className="userArea">
            <div className="userInfoArea text-right">
              <div className="userName">
                {this.props.generalProfile.fullname}
              </div>
              <div className="userTitle">
                {this.props.generalProfile.positionName}
              </div>
              <div className="userCompanyTitle">
                {this.props.generalProfile.companyName}
              </div>
            </div>
            <div
              className={`userImgArea ${this.props.generalProfile.gradeType
                ? this.props.generalProfile.gradeType.label
                : ""
                }`}
            >
              {this.props.generalProfile.gradeType ? (
                <span className="icon-icon-menu-badge"></span>
              ) : null}
              {this.renderUserImage()}
            </div>
          </div>
        </a>
        {/* <a href="#" onClick={() => this.handleWorkerMessage(10)}>
          RT
        </a> */}
        <DesktopBreakpoint>
          <ul className="userSubmenu">
            <li>
              <Link to="/profile#general">
                <span className="iconmford fo-icon-account-circle"></span>
                <span>
                  <Trans desc="Genel Bilgiler">10059</Trans>
                </span>
              </Link>
            </li>
            <li>
              <Link to="/profile#contact">
                <span className="iconmford fo-icon-perm-phone-msg"></span>
                <span>
                  <Trans desc="İletişim Bilgileri">10060</Trans>
                </span>
              </Link>
            </li>
            <li>
              <Link to="/profile#other">
                <span className="iconmford fo-icon-info"></span>
                <span>
                  <Trans desc="Diğer Bilgiler">10061</Trans>
                </span>
              </Link>
            </li>
            <li>
              <Link to="/profile#company">
                <span className="iconmford fo-icon-account-circle"></span>
                <span>
                  {/* <Trans desc="Bayi">10565</Trans> - */}
                  {this.props.generalProfile.companyName}
                </span>
              </Link>
            </li>
            {
              this.props.generalProfile.isKocAilemAvailability &&
              <li>
                <Link to="/profile#kocAilem">
                  <span className="iconmford fo-icon-account-circle"></span>
                  <span>
                    <Trans desc="Koç Ailem Üyelik Bilgieri">10739</Trans>
                  </span>
                </Link>
              </li>
            }
            {/* <li>
            <a href="#">
              <span className="icon-icon-menu-settings"></span>{" "}
              <span>Ayarlar</span>
            </a>
          </li> */}
            {/* <li>
            <a href="#">
              <span className="icon-icon-menu-password"></span>
              <span>Şifre Değiştirme</span>
            </a>
          </li> */}
            <li className="cikisButonu">
              <a href="/logout">
                <span className="iconmford fo-icon-exit-to-app"></span>{" "}
                <span>
                  <Trans desc="Çıkış">10062</Trans>
                </span>
              </a>
            </li>
          </ul>
        </DesktopBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
    modal: state.modal,
    application: state.application,
    auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getFile,
  showModal,
})(withRouter(containsLongRunningProcess(Profilebar)));
